import { atom } from 'recoil';

enum StateKey {
  notificationCountState = 'notificationCountState'
}

export const notificationCountState = atom({
  key: StateKey.notificationCountState,
  default: 0
});
